import React from 'react';
import {
  Modal, ModalBody, Button,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getContactName, { getLabelFromType } from '../../../utils/functions';

class ModalAdd extends React.Component {
  static propTypes = {
    itemInfo: PropTypes.shape({}).isRequired,
    assetData: PropTypes.shape({}).isRequired,
    toggle: PropTypes.func.isRequired,
    isModal: PropTypes.bool.isRequired,
    contacts: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    user: PropTypes.shape({}).isRequired,
    setDocument: PropTypes.func,
  };

  static defaultProps = {
    setDocument: () => {},
  };

  constructor(props) {
    super(props);
    const { assetData } = props;
    const editingProps = {};
    if (assetData._id) {
      Object.keys(assetData).forEach((e) => {
        if (assetData[e]) {
          editingProps[e] = assetData[e];
        }
      });
    }
    console.log('editing props', editingProps);
    this.state = {
      ...editingProps,
    };
  }

  renderContent = () => {
    const {
      contacts, itemInfo, assetData, setDocument,
    } = this.props;
    return (
      <ModalBody style={{ padding: '2rem' }}>
        {
          itemInfo.form && itemInfo.form.map((item) => {
            if ((item.type === 'input' || item.type === 'insurance' || item.type === 'textarea') && assetData[item.value]) {
              return (
                <div className="mb-20" key={item.value}>
                  <div className="bold-text">
                    {item.label} :
                  </div>
                  <div className="pre-line">
                    {assetData[item.value]}
                  </div>
                </div>
              );
            }
            if ((item.type === 'insurance_type') && assetData[item.value]) {
              return (
                <div className="mb-20" key={item.value}>
                  <div className="bold-text">
                    Type d'assurance :
                  </div>
                  <div className="pre-line">
                    {getLabelFromType(assetData.subcategory, assetData.type)}
                  </div>
                </div>
              );
            }
            if (item.type === 'contact' && assetData.contacts && assetData.contacts.length > 0) {
              return (
                <div className="mb-20" key={item.value}>
                  <div className="bold-text">
                    {item.label} :
                  </div>
                  <div>
                    {assetData.contacts.map(contact => (
                      <div key={contact}>
                        {getContactName(contacts, contact)}
                      </div>
                    ))}
                  </div>
                </div>
              );
            }
            if (item.type === 'documents' && assetData.documents && assetData.documents.length > 0) {
              return (
                <div className="mb-20" key={item.value}>
                  <div className="bold-text">
                    Documents :
                  </div>
                  <div>
                    {assetData.documents.map(doc => (
                      <div key={doc}>
                        <Button className="blueish" color="link" onClick={() => setDocument(doc)}>{doc.name || 'Titre manquant'}</Button>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }
            return null;
          })
        }
      </ModalBody>
    );
  };

  render() {
    const {
      toggle, itemInfo, isModal,
    } = this.props;

    return (
      <Modal
        isOpen={isModal}
        toggle={toggle}
        modalClassName="ltr-support"
        className="modal-dialog--lightOfficial modal-dialog--header theme-light mb-20"
      >
        <div className="modal__header">
          <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
          <h4 className="semiBold text-modal modal__title">
            {itemInfo.title}
          </h4>
          {itemInfo.help && <div><a href={itemInfo.help.url} rel="noopener noreferrer" target="_blank" className="small-underline underline additional-text">{itemInfo.help.label}</a></div>}
        </div>
        {this.renderContent()}
      </Modal>
    );
  }
}

export default connect(state => ({
  contacts: state.contacts,
  user: state.user,
}))(ModalAdd);
